import { useGlobal } from '@common/core-layer/composables/useGlobal'
import { getDeviceInfo } from '../../core-layer/utils'
import { BaseService } from '../../http-layer/service/base.service'

import type { LoginWithSecureCodePayload } from '../types'

/**
 * OTP service - handles OTP generation and verification API calls
 */
class OTPService extends BaseService {
  private readonly isMeet: boolean

  constructor() {
    const { isMeet } = useGlobal()
    super({
      baseURL: 'CLIENTPORTAL_SERVER_URL',
      basePath: '/otps',
    })
    this.isMeet = isMeet
  }

  async generateOTPForLogin(payload: LoginWithSecureCodePayload): Promise<{ data: { otpToken: string; isNewUser?: boolean } }> {
    const { data } = await this.post<{ otpToken: string; token?: string; isNewUser?: boolean }>(`/${payload.locationId}/send`, {
      email: payload.email,
      locationId: payload.locationId,
      action: payload.action || null,
      captchaToken: payload.captchaToken,
      ...getDeviceInfo(),
    })

    return { data: { otpToken: this.isMeet ? data.token! : data.otpToken, isNewUser: data.isNewUser } }
  }

  async validateOtp(payload: { email: string; otp: number; locationId: string; token: string }): Promise<{ data: { valid: boolean } }> {
    const { data } = await this.post<{ valid: boolean }>(`/${payload.locationId}/validate`, {
      email: payload.email,
      otp: payload.otp,
      locationId: payload.locationId,
      token: payload.token,
    })

    return { data }
  }
}

// Export class for instantiation when needed
export { OTPService }
